<template>
    <aside>
        <div class="section-data" style="min-height: 400px;">
            <div class="title d-flex justify-content-between">
                <div class="text">
                    <div id="slot-title">
                    </div>
                    <h3 class="font-blue">Compatibilidad (Match personalizado)</h3>
                    <p class="font-gray-dark">Coloca en el orden de tu preferencia,
                        los puntos que consideres más importantes para encontrar el candidato
                        ideal para tu vacante
                    </p>
                </div>
                <div class="tools">
                    <div id="slot-tools">
                    </div>
                </div>
            </div>
            <div class="data">
                <div class="container my-3">
                    <div id="slot-content">
                    </div>
                    <div class="content pb-5">

                        <div class="target-downloading text-center p-1 font-gray-dark" v-if="downloading">
                            <b-spinner small label="Espere ..."></b-spinner>
                            <span class="p-1">Espere un momento...</span>
                        </div>

                        <div class="target-body pb-5" v-show="!downloading">
                            <b-button class="b-gray-light  mb-5">
                                ¿Necesitas ayuda?
                            </b-button>

                            <draggable v-model="preferences" :move="movedPreferences">

                                <div v-for="(element, index) in preferences"
                                     :key="index"
                                     class="shadow mb-3 p-3">
                                    <div class="row p-1">
                                        <div class="font-blue h5 col">
                                            {{ i = index + 1 + '.- ' + text[element.name].name }}
                                        </div>
                                        <div class="font-blue h5 col">

                                            <i class="fas fa-bars mt-2 float-right percentage"
                                            ></i>

                                            <a class="mt-2 float-right mr-5 percentage"
                                               v-b-tooltip.hover title="Click para editar"
                                               @click="showModal(element, index,text[element.name].name, )">
                                                {{ element.percentage | twoDecimals }}%
                                            </a>

                                        </div>

                                    </div>
                                </div>

                            </draggable>

                            <div class=" mb-3 p-3">
                                <div class="row p-1">
                                    <div class="font-blue h5 col">

                                    </div>
                                    <div class="font-blue h5 col">

                                        <i class="fas fa-bars mt-2 float-right text-white"></i>

                                        <span class="mt-2 float-right mr-5 percentage">
                                            Porcentaje actual {{ total_percentage }}%
                                        </span>

                                    </div>

                                </div>
                            </div>

                            <div class="my-3 p-3" v-if="total_percentage!==100">
                                <div class="row p-1 font-blue float-right">
                                    El porcentaje actual debe ser igual a 100% para poder guardar los
                                    cambios.
                                </div>
                            </div>

                            <b-button @click="savePreferences"
                                      size="lg"
                                      class="float-right shadow b-green mt-3 "
                                      :disabled="total_percentage!==100">
                                <b-spinner v-if="loading" small label="Espere ..."></b-spinner>
                                {{ loading ? 'Aplicar Cambios' : 'Guardar' }}
                            </b-button>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modal-center" centered
                 hide-footer
                 hide-header
                 no-close-on-backdrop
                 no-close-on-esc
                 v-model="modal.show">
            <div class="col-12 p-5">
                <h5 class="font-blue">Porcentaje {{ modal.text }}</h5>

                <form @submit.prevent="setPercentage">

                    <div class="form-group">
                        <!--                        <label for="number">Porcentaje actual:-->
                        <!--                            <b :class="{ 'text-danger': is100}">{{ sum_percentage }}%</b>-->
                        <!--                        </label>-->
                        <input type="number"
                               v-model="modal.value"
                               class="form-control"
                               min="0"
                               max="100"
                               placeholder="10%"
                               id="number"
                               aria-describedby="numberHelp"
                               @keyup="calculatePercentage"
                        >
                        <small class="form-text text-danger" v-if="is100">
                            El porcentaje actual excede el <b>100%</b>, asigne un valor menor.<br>
                            También puede restar a otras secciones para tener disponible un valor
                            de asignación.
                        </small>
                        <small class="form-text text-muted" v-else>
                            Debe teclear un valor numérico para el porcentaje
                        </small>
                    </div>
                    <b-button :class="{'btn-success':!is100}" type="submit" :disabled="is100">
                        Guardar
                    </b-button>
                    <b-button @click="closeModal">Cancelar</b-button>
                </form>
            </div>

        </b-modal>

        <b-modal id="modal-help"
                 hide-footer
                 hide-header
        >
            <div class="col-12 p-5">


            </div>
        </b-modal>
    </aside>
</template>

<script>
import draggable from 'vuedraggable'

export default {
    name: "Match",
    components: {
        draggable,
    },
    data() {
        return {
            loading: false,
            downloading: false,
            text: {
                'Experience': {name: 'Experiencia'},
                'Education': {name: 'Educación'},
                'Skills': {name: 'Habilidad'},
                'Software': {name: 'Software'},
                'Proyects': {name: 'Proyectos'},
                'Achievements': {name: 'Servicios'},
                'StudentInfo': {name: 'Ubicación'},
            },
            preferences: [],
            filters: {},
            job_id: 0,
            total_percentage: 100,
            has_percentage: 0,
            modal: {
                name: '',
                show: false,
                current_value: 0,
                value: 0,
                text: '',
                index: 0,
            },
            is100: false,
            modal_hepl: [
                {
                    text: 'Coloca el cursor sobre el menú de tres lineas de la palabra que deseas mover.<br>' +
                        'Haz clic sobre este y arrastra la tabla hacía la posición que quieras que ocupe,' +
                        'de acuerdo a la importancia quwe tenga para tu vacante.'
                },
                {
                    text: 'En el valor de porcentaje del lado derecho puedes editar directamente de acuerdo a la importancia,' +
                        'que tenga tu vacante, estos se ajustarán automaticamente de mayor a menor según el valor.'
                }
            ],


        }
    },
    computed: {},
    methods: {
        movedPreferences(evt) {
            let name = evt.draggedContext.element.name
            let percentage = evt.draggedContext.element.percentage
            let index = evt.draggedContext.index
            let futureIndex = evt.draggedContext.futureIndex
            //add values to save
            this.preferences[index].percentage = this.preferences[futureIndex].percentage
            this.preferences[futureIndex].percentage = percentage
        },
        showModal(element, index, text) {
            this.modal.show = !this.modal.show
            this.modal.value = element.percentage
            this.modal.current_value = element.percentage
            this.modal.text = text
            this.modal.name = element.name
            this.modal.index = index
        },
        closeModal() {
            this.preferences[this.modal.index].percentage = this.modal.current_value
            this.modal.show = !this.modal.show
            this.is100 = false
            let sum = 0
            for (let [index, item] of this.preferences.entries()) {
                sum = sum + ((item.percentage === '') ? 0 : parseFloat(item.percentage))
            }

            this.total_percentage = sum

        },
        calculatePercentage() {

            this.preferences[this.modal.index].percentage = this.modal.value

            let sum = 0
            for (let [index, item] of this.preferences.entries()) {
                sum = sum + ((item.percentage === '') ? 0 : parseFloat(item.percentage))
            }
            this.is100 = (sum > 100)
            this.total_percentage = sum
        },
        sortPreferences() {

            return this.preferences.sort((a, b) => {
                if (parseFloat(a.percentage) > parseFloat(b.percentage)) {
                    return -1;
                }
                if (parseFloat(a.percentage) > parseFloat(b.percentage)) {
                    return 1;
                }
                return 0;
            })

        },
        assignPreferences() {

            this.total_percentage = 0
            let sum = 0, listened = [0, 1, 2, 3, 4, 5]
            let preferences = this.preferences.entries()

            for (let [index, item] of preferences) {
                sum = sum + ((item.percentage === '') ? 0 : parseFloat(item.percentage))
                if (item.edit === true) {
                    listened = listened.filter(i => {
                        return i !== index
                    })
                }
            }

            if (listened.length > 0) {

                let addsum = (100 - sum) / parseFloat(listened.length)

                for (let index of listened) {
                    console.log(this.preferences[index].percentage)
                    this.preferences[index].percentage = (this.preferences[index].percentage + addsum)
                }

            }

        },


        setPercentage() {
            this.preferences[this.modal.index].percentage = (this.modal.value === '') ? 0 : parseFloat(this.modal.value)
            this.preferences[this.modal.index].edit = true

            this.modal.show = !this.modal.show

            this.calculatePercentage()
            this.sortPreferences()
        },


        toast(message, success) {
            if (success) {

                this.$bvToast.toast(message, {
                    title: "Kllaar.com",
                    variant: 'success',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                })

            } else {
                this.$bvToast.toast('Ocurrió un error', {
                    title: "Kllaar.com",
                    variant: 'danger',
                    toaster: 'b-toaster-bottom-right',
                    solid: true,
                    appendToast: true
                })
            }
        },
        savePreferences() {
            this.loading = true

            for (let item of this.preferences.values()) {
                let key = Object.keys(item)[2]
                this.filters[item.name].percentage = item.percentage
            }

            this.api.put('enterprise/job/update/preferences/' + this.job_id, {filters: this.filters})
                .then(({data}) => {
                    this.toast(data.message, data.success)
                    this.loading = false
                }).catch(err => {
                this.toast(err.message, err.success)
                console.log('error add filters')
                this.loading = false
            })

        }
    },
    created() {

        let id = this.$route.params.id
        this.job_id = id

        if (id !== undefined) {
            this.id = id
            this.downloading = true

            this.api.get('enterprise/job/find/' + id).then(({data}) => {
                this.downloading = false
                this.filters = JSON.parse(data.body.filters)

                for (const property of Object.keys(this.filters)) {
                    for (const exits in this.text) {
                        if (property===exits){
                            this.preferences.push({
                                percentage: this.filters[property].percentage,
                                name: property,
                                property : false,
                                edit: false
                            })
                        }
                    }
                }

                this.sortPreferences()
            }).catch(err => {
                this.downloading = false
                console.log(err)
            })

        }
    },
    // watch: {
    //     has_percentage: function() {
    //         this.has_percentage = (100 - this.total_percentage)
    //     },
    // },
    filters: {
        twoDecimals(val) {
            return val;
            //Number.parseFloat(val).toFixed(2)
        }
    }
}
</script>
<style lang="scss">
.percentage:hover {
  cursor: pointer;
}

.target {
  margin-top: 0;
}

.section {
  &-data {
    background: #fff !important;
    -webkit-box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075) !important;
    border-radius: .25rem !important;

    .title {
      padding: 15px 0 0 15px;
      border-bottom: 1px solid #EEEEEE;
    }

    .data {
      .is-empty, .is-loading {
        padding: 45px;
        text-align: center;
        justify-content: center;
        align-content: center;

        img {
          opacity: .5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/Match.vue